import { Component, inject } from '@angular/core';
import { MaterialModule } from '../../modules/material/material.module';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faAnglesDown, faUser, faEnvelope, faRotate, faAddressCard, faUserPlus, faPhone, faCalendarDays, faCartShopping, faTrashCan, faTriangleExclamation, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { MemberService } from '../../services/member.service';
import {MatTableModule} from '@angular/material/table';
import { LinkService } from '../../services/link.service';
import { SelectButton } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { updatePreset } from '@primeng/themes';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
];

export interface MemberEntry {
  tvxPlusId: String;
  name: string;
}

export interface LinkEntry {
  pan: String;
  tvxPlusId: string;
}

const MEMBERS_DATA: MemberEntry[] = [
  // {position: 1, pan: "4111111111111111"},
  // {position: 2, pan: "4242424242424242"},
  // {position: 3, pan: "5555555555555555"},
];

const LINKS_DATA: LinkEntry[] = [
  // {position: 1, pan: "4111111111111111"},
  // {position: 2, pan: "4242424242424242"},
  // {position: 3, pan: "5555555555555555"},
];

// updatePreset({
//         semantic: {
//             primary: {
//                 50: '{indigo.50}',
//                 100: '{indigo.100}',
//                 200: '{indigo.200}',
//                 300: '{indigo.300}',
//                 400: '{indigo.400}',
//                 500: '{indigo.500}',
//                 600: '{indigo.600}',
//                 700: '{indigo.700}',
//                 800: '{indigo.800}',
//                 900: '{indigo.900}',
//                 950: '{indigo.950}'
//             }
//         }
//     })

@Component({
  selector: 'app-magement-page',
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatTableModule,
    FormsModule, 
    SelectButton,
    ButtonModule
  ],
  templateUrl: './magement-page.component.html',
  styleUrl: './magement-page.component.scss'
})
export class MagementPageComponent {

  stateOptions: any[] = [{ label: 'Members', value: 'members' },{ label: 'Links', value: 'links' }];
  tableType: string = 'members';

  membersDisplayedColumns: string[] = [ 'tvxPlusId', 'name', 'symbol'];
  membersDataSource = MEMBERS_DATA;

  linksDisplayedColumns: string[] = [ 'pan', 'tvxPlusId', 'symbol'];
  linksDataSource = LINKS_DATA;


  private memberService = inject(MemberService);
  private linkService = inject(LinkService);

  transactionId: string = '';
  registerLoading: boolean = false;
  registrationSuccess: boolean = true;

  tvxIdControl = new FormControl('', [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(10),
  ]);
  tcControl = new FormControl(false, [Validators.requiredTrue]);

  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public library: FaIconLibrary
  ) {
    library.addIcons(
      // faAnglesDown,
      faUser,
      // faRotate,
      faAddressCard,
      // faUserPlus,
      // faEnvelope,
      // faPhone,
      // faCalendarDays,
      // faCartShopping,
      // faTrashCan,
      // faTriangleExclamation,
      faCheckCircle
    );
  }

  ngOnInit() {
    this.refreshMembersTable();
    this.refreshLinksTable();
  }

  refreshAllTablesBtn(){
    console.log('Refreshing all tables...');
    this.refreshMembersTable();
    this.refreshLinksTable();
  }

  refreshMembersTable(){
    this.memberService.getMembers().subscribe(
      (response) => {
        console.log('Members fetched successfully:', response);
        this.membersDataSource = response.members.map((member, index) => ({
          tvxPlusId: member.tvxPlusId,
          name: member.firstName + ' ' + member.lastName,
          registered: member.registered,
        }));
      },
      (error) => {
        console.error('Error fetching members:', error);
      }
    );
  }

  refreshLinksTable(){
    this.linkService.getLinks().subscribe(
      (response) => {
        console.log('Links fetched successfully:', response);
        this.linksDataSource = response.links.map((link, index) => ({
          pan: link.pan,
          tvxPlusId: link.tvxPlusId,
          registered: link.registered,
        }));
      },
      (error) => {
        console.error('Error fetching members:', error);
      }
    );
  }

  displayPan(pan: string) {
    return pan.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
    // return pan.substring(0, 6) + ' *** ' + pan.substring(12, 16);
  }

  deleteMember(tvxPlusId: string) {
    console.log('Deleting tvxPlusId:', tvxPlusId);
    this.memberService.removeMember(tvxPlusId).subscribe(
      (response) => {
        console.log('Deletion successful:', response);
        this.membersDataSource = this.membersDataSource.filter((entry) => entry.tvxPlusId !== tvxPlusId);
        this.refreshMembersTable();
        this.refreshLinksTable();
      },
      (error) => {
        console.error('Deletion failed:', error);
      }
    );
  }

  deleteLink(pan: string) {
    console.log('Deleting link for Pan:', pan);
    this.linkService.removeLink(pan).subscribe(
      (response) => {
        console.log('Deletion successful:', response);
        this.linksDataSource = this.linksDataSource.filter((entry) => entry.pan !== pan);
        this.refreshMembersTable();
        this.refreshLinksTable();
      },
      (error) => {
        console.error('Deletion failed:', error);
      }
    );
  }
}

